import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { Error } from './pages/Error';
import { ThankYou } from './pages/ThankYou';
import { Footer } from './components/Footer';
import { CookieBanner } from './components/CookieBanner';
import GoogleAnalytics from './components/GoogleAnalytics';

import './styles/custom.sass';

function App() {
  return (
    <BrowserRouter>
      <GoogleAnalytics />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/thank-you' element={<ThankYou />} />
        <Route path='*' element={<Error />} />
      </Routes>
      <Footer />
      <CookieBanner />
    </BrowserRouter>
  );
}

export { App };
